// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

export function proconClear(): ReducerAction {
	return {
		type: Types.PROCON_CLEAR,
		payload: null,
	};
}
